module.exports = __webpack_public_path__ + "media/hero.17f7c7c9.mp4";